// Staff login screen (§6.1).
//
// Reuses the recon's restaurant-staff login pattern: POST /restaurant/authenticate
// with {email,password}. On success we store the signed RestaurantUser token under
// `hw_staff_profile` (distinct from the customer `user_profile`) and hand the session
// up to the parent. Fail-safe: any error renders an inline message, never crashes.
import React, { useState } from 'react';
import { staffLogin, setStaffSession, describeError } from './api';

export default function StaffLogin({ onLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (busy) return;
    setError('');
    if (!email.trim() || !password) {
      setError('Enter your staff email and password.');
      return;
    }
    setBusy(true);
    try {
      const session = await staffLogin(email.trim(), password);
      setStaffSession(session);
      if (onLoggedIn) onLoggedIn(session);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="staff-root">
      <div className="staff-shell staff-login">
        <div className="staff-brand">
          <div className="staff-brand-title">heywaitr Staff</div>
          {/* The tool grew a ticket scanner; the sign-in page still promised only
              stamp cards, which is the first thing door staff read. */}
          <div className="staff-brand-sub">Stamp cards, rewards &amp; tickets</div>
        </div>

        <form className="staff-card" onSubmit={submit}>
          <h2>Sign in</h2>
          <p className="staff-hint">Use your restaurant staff account.</p>

          {error ? <div className="staff-alert is-error">{error}</div> : null}

          <label className="staff-label" htmlFor="staff-email">
            Email
          </label>
          <input
            id="staff-email"
            className="staff-input"
            type="email"
            autoComplete="username"
            inputMode="email"
            placeholder="you@restaurant.com"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
          />

          <label className="staff-label" htmlFor="staff-pass">
            Password
          </label>
          <input
            id="staff-pass"
            className="staff-input"
            type="password"
            autoComplete="current-password"
            placeholder="Password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
          />

          <button className="staff-btn" type="submit" disabled={busy}>
            {busy ? <span className="staff-spinner" /> : null}
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="staff-footnote">No install needed — bookmark this page.</div>
      </div>
    </div>
  );
}
